import { render, staticRenderFns } from "./ReportNoteModificaSegnalazione.vue?vue&type=template&id=6f3272f6&scoped=true&lang=pug&"
import script from "./ReportNoteModificaSegnalazione.vue?vue&type=script&lang=ts&"
export * from "./ReportNoteModificaSegnalazione.vue?vue&type=script&lang=ts&"
import style0 from "./ReportNoteModificaSegnalazione.vue?vue&type=style&index=0&id=6f3272f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3272f6",
  null
  
)

export default component.exports